export default __webpack_public_path__ + "static/media/play_icon.a51e6fd9.svg";